export default ({ app, $axios, store, req }, inject) => {

    inject('api', () => {
        const defaultOptions = {
            baseURL: process.env.SPORTSBOOK_API + '/',
            headers: {
                'Content-Type': 'application/json',
                'bookmaker': process.env.BOOKMAKER,
            },
        };
    
        // Create instance
        let instance = app.$axios.create(defaultOptions);
        instance.interceptors.request.use(function (config) {
            config.headers.jwt =  localStorage.getItem('jwt');
            return config;
        });

        return instance
    })

  inject('infoapi', () => {
    const defaultOptions = {
      baseURL: process.env.SPORTSBOOK_API + '/',
      headers: {
        'Content-Type': 'application/json',
        'bookmaker': process.env.BOOKMAKER,
      },
    };

    // Create instance
    let instance = app.$axios.create(defaultOptions);
    instance.interceptors.request.use(function (config) {
      if (process.client) {
        config.headers.jwt =  localStorage.getItem('jwt');
      }
      return config;
    });

    return instance
  })  
    
    inject('cached', () => {
        const defaultOptions = {
            baseURL: app.$config.SPORTSBOOK_CDN + '/',
            headers: {
                'Content-Type': 'application/json',
                'bookmaker': process.env.BOOKMAKER,
            },
        };
        // Create instance
        let instance = app.$axios.create(defaultOptions);
        instance.interceptors.request.use(function (config) {
          if (process.client) {
            config.headers.jwt =  localStorage.getItem('jwt');
          }
          return config;
        });

        return instance
    })

    inject('content', () => {
        const defaultOptions = {
            baseURL: app.$config.CONTENT_API + '/api/content',
            headers: {
                'Content-Type': 'application/json',
                //'jwt': localStorage.getItem('jwt'),
                'bookmaker': process.env.BOOKMAKER,
            },
        };
        
        // Create instance
        let instance = app.$axios.create(defaultOptions);
        instance.interceptors.request.use(function (config) {
            //config.headers.jwt =  localStorage.getItem('jwt');
            config.headers.bookmaker = process.env.BOOKMAKER;
            return config;
          });
        return instance
    })


  inject('new_cms', () => {
    let jwtCookie = ''

    if (process.server) {
      const cookieParser = require('cookie');
      const cookies = cookieParser.parse(req.headers.cookie);
      jwtCookie = cookies.jwt || '';
    } else if (process.client) {
      // Get cookie on client side using $cookies from cookie-universal-nuxt
      jwtCookie = app.$cookies.get('jwt') || '';
    }


  const defaultOptions = {
      baseURL: app.$config.NEW_CMS_URL,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        'jwt': jwtCookie,
      },
    };
    let instance = app.$axios.create(defaultOptions);
    instance.interceptors.request.use(function (config) {
      config.headers.jwt = jwtCookie;
      return config;
    });
    return instance
  })
  
    inject('cms', () => {
        const defaultOptions = {
            baseURL: app.$config.CMS_URL + '/api',
            headers: {
                'Content-Type': 'application/json',
            },
        };
        let instance = app.$axios.create(defaultOptions);
        return instance
    })

    inject('cmscasino', () => {
      const defaultOptions = {
        baseURL: app.$config.CONTENT_777_API + '/api/common/content',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      return app.$axios.create(defaultOptions)
    })

  inject('content777db', () => {
    const defaultOptions = {
      baseURL: app.$config.CONTENT_777_API + '/api/sport',
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return app.$axios.create(defaultOptions)
  })

  inject("nbsapi", () => {
        const defaultOptions = {
        baseURL: app.$config.NBS_API + '/tournaments',
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
            bookmaker: process.env.BOOKMAKER,
        },
        };

        // Create instance
        let instance = app.$axios.create(defaultOptions);
        instance.interceptors.request.use(function (config) {
        //config.headers.jwt =  localStorage.getItem('jwt');
        config.headers.bookmaker = process.env.BOOKMAKER;
        return config;
        });
        return instance;
    });

    inject('content777', () => {
        const defaultOptions = {
            baseURL: app.$config.CONTENT_777_API + '/api/sport',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('jwt'),
            },
        };
        
        // Create instance
        let instance = app.$axios.create(defaultOptions);
        instance.interceptors.request.use(function (config) {
            config.headers.jwt =  localStorage.getItem('jwt');
            return config;
          });
        return instance
    })
}
